import { OAuth2Api } from "@devour/client";
import { useQuery } from "@tanstack/react-query";

async function fetchOAuthClient(oAuthClientId: string) {
    return await new OAuth2Api().getOauthClientsId({
        id: oAuthClientId,
    });
}

function getOAuthClient(oAuthClientId: string) {
    return {
        queryKey: [
            "get-oauth-client",
            oAuthClientId,
        ],
        queryFn: () => fetchOAuthClient(oAuthClientId),
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
        enabled: Boolean(oAuthClientId),
    } as const;
}

export function useGetOAuthClient(oAuthClientId: string) {
    return useQuery(getOAuthClient(oAuthClientId));
}
